import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  currentFilter: PropTypes.string,
  displayTest: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  currentFilter: null,
  className: null,
};

const Filter = ({ children, displayTest, currentFilter, onFilter, className }) => {
  if (!displayTest()) { return null; }

  const childArray = Array.isArray(children) ? children : [children].filter(c => c);
  let filterIndex = childArray.indexOf(childArray.find(c => c.props.filter === currentFilter));
  filterIndex = Math.max(filterIndex, 0);

  return (
    <div className={`row filter ${className}`}>
      <div className={`filter-highlight col-md-2 col-xs-6 col-md-offset-${filterIndex * 2} col-xs-offset-${filterIndex * 6}`} />
      {Children.map(childArray, child => cloneElement(child, { onFilter, currentFilter }))}
    </div>
  );
};

Filter.propTypes = propTypes;
Filter.defaultProps = defaultProps;

export default Filter;

